module.exports = __webpack_public_path__ + "img/date-range.fabdb35e.svg";